import React from 'react'
import ExcelUpload from '../../components/common/excel-upload/excel-upload'
const PDIExcelGiris = () => {
    return (
        <>
            <ExcelUpload
                role_name={"pdiexcel_giris_write"}
                requiredColumnsSase={["sase", "pdi_entry_date"]}
                process_type="PDI_ENTRY"
                ExcelName={"PDI Giriş Hatalı Şaseler"}
                Title={"PDI Giriş"}
                exampleData={[
                    { sase: "VF3YEF6F0RMA03711", pdi_entry_date: "01.01.2025" },
                ]}
            />
        </>
    )
}

export default PDIExcelGiris